import type { EventLogGroup, LogType } from '../cubits/AdminInspectorCubit'

// Rows that never merge with their neighbours. A merged group sits at its first
// row's time, and a Sentry error is only useful next to what happened just
// before and after it.
const UNGROUPED_EVENT_NAMES = new Set(['sentry_error_sent'])

// Collapses consecutive rows from one user with the same event name into one
// group. `logs` must already be in timeline order.
export function groupInspectorLogs(logs: LogType[]): EventLogGroup[] {
  let last: EventLogGroup | null = null

  const groupedLogs: EventLogGroup[] = []

  for (const log of logs) {
    if (
      !last ||
      last.user_id !== log.user_id ||
      last.event_name !== log.event_name ||
      UNGROUPED_EVENT_NAMES.has(log.event_name)
    ) {
      last = {
        event_date: log.event_date,
        user_id: log.user_id,
        event_name: log.event_name,
        events: [log],
      }

      groupedLogs.push(last)
    } else {
      last.events.push(log)
    }
  }

  return groupedLogs
}
